
































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import TransferAudienceCreativesTrigger from './TransferAudienceCreativesTrigger.coffee'

settings =
  name: 'TransferAudienceCreativesTriggerModal'
  resources:
    organizers:
      resourceName: 'organizer'
      slug: 'suppliers/:supplierId/organizers'
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    mixins: [TransferAudienceCreativesTrigger.trigger()]

    components: {
      Modal,
      RequestButton,
      LoadingIndicator,
    }

    computed:
      modalConfig: -> @modal.config || {}
      supplierId: -> @modalConfig.supplierId
      currentOrganizerId: -> @modalConfig.currentOrganizerId
      avaliableOrganizers: -> (@organizers || []).filter((o) => o.id isnt @currentOrganizerId)

    methods:
      formatLabelForOrganizer: (organizer) ->
        tokens = [organizer.first_name, organizer.last_name]
        tokens.filter(Boolean).join ' '

    watch:
      'modal.show': (show) ->
        @fetch 'organizers' if show

export default VueOptions.vue settings
